module.exports = __webpack_public_path__ + "img/LasMisionesLogo.f48e022e.png";